import { Stack } from '../../../../../design-system/stack/stack';
import { LoadingInvoice } from './loading-invoice';

type LoadingInvoiceWrapperProps = {
  onCancel: () => void;
};

export const LoadingInvoiceWrapper = ({ onCancel }: LoadingInvoiceWrapperProps) => {
  return (
    <Stack justify="center" align="center" className="h-full flex-1">
      <LoadingInvoice onCancel={onCancel} />
    </Stack>
  );
};
